import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import api from 'services/api/api';
import { getApiConfig, getApiConfigSticky } from 'reducers/response';
import API, {
  updateDefaults,
  getApaAssets,
  getApaMetadata,
} from 'services/api/microfwk';
import { getTranslations, responseAsset } from 'actions/response';
import { GetRegion } from 'constants.js';
import apiSticky, { updateDefaultsSticky } from 'services/api/microfwkSticky';
import { useDispatch } from 'react-redux';
import getConfigEnv from 'utils/getConfigEnv';
import { responseMetadata } from 'actions/response';
import launchRedirect from 'utils/LaunchRedirect';
import { getHKS, setHKS } from 'utils/HKS';
import { apiCall, updateSwaggerManager } from '../../api';
import { jsonParseTraslation, jsonParseCatch } from 'utils/getTranslation';
import { getUserIsKids } from 'utils/User';
import { useNavigate } from 'react-router-dom';
const getAppKey = region => `531eed34tvfy7b73a818a234-${region}`;

export const useHandleBoostrapProvider = () => {
  const [shiModel, setShiModel] = useState(null);
  const [configModel, setConfigModel] = useState(null);
  const [metadataModel, setMetadataModel] = useState(null);
  const [assetModel, setAssetModel] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getRegion = shiRes => {
    let region = '';
    const isDiferentRegion = localStorage.getItem('loginInfo.diferentRegion');
    if (isDiferentRegion) {
      region = localStorage.getItem('loginInfo.region');
    } else {
      region = _.get(shiRes, ['response', 'region']);
    }
    setShiModel(shiRes);
    return region;
  };
  const updateApiCallParams = configData => {
    window.getConfig = configData;

    const {
      api_version,
      ...rest
    } = window.getConfig.config.general.api_params_default;
    window.getConfig.api_swager_params = {
      ...rest,
    };
    api.setConfig(configData);
    const apiConfig = getApiConfig(configData);
    const apiConfigSticky = getApiConfigSticky(configData);
    Promise.all([
      updateSwaggerManager(apiCall, window.getConfig.api_swager_params),
      updateDefaults(API, apiConfig),
      updateDefaultsSticky(apiSticky, apiConfigSticky),
    ]);
  };

  const fetchApas = async region => {
    const metadataPromise = getApaMetadata({
      sessionKey: getAppKey(region),
    });
    const assetsPromise = getApaAssets({
      sessionKey: getAppKey(region),
    });
    const [metadataRes, assetsRes] = await Promise.all([
      metadataPromise,
      assetsPromise,
    ]);
    return { metadataRes, assetsRes };
  };
  const redirectFromRoot = metadataRes => {
    const pathArray = window.location.pathname.split('/');
    const isIncorrectHome =
      (pathArray?.[pathArray.length - 1] === 'homeuser' && getUserIsKids()) ||
      (pathArray?.[pathArray.length - 1] === 'homeuser_kids' &&
        !getUserIsKids());

    const inRoot = window.location.pathname === '/';
    if (inRoot || isIncorrectHome) {
      const adsConfig = metadataRes?.cv_advertising_config
        ? JSON.parse(metadataRes?.cv_advertising_config || '{}')
        : {};
      launchRedirect(adsConfig, navigate);
    }
  };
  const storeApas = metadataRes => {
    //store metadat at redux and window object
    dispatch(responseMetadata(metadataRes));
    window.metadata = metadataRes;

    const translations = JSON.parse(metadataRes?.translations)?.language[
      GetRegion()
    ];
    //store translation at redux and window object
    dispatch(getTranslations(translations));
    window.translations = translations;
  };
  const boot = async cb => {
    console.log('REBOOT');
    try {
      const shiRes = jsonParseCatch(
        localStorage.getItem('startHeaderInfoResponse'),
      );
      setHKS(_.get(shiRes, ['response', 'session_stringvalue']));

      const region = getRegion(shiRes);
      localStorage.setItem('loginInfo.region', region);
      const configData = getConfigEnv(region);
      updateApiCallParams(configData);

      const { metadataRes, assetsRes } = (await fetchApas(region)) || {};

      redirectFromRoot(metadataRes);
      storeApas(metadataRes);
      dispatch(responseAsset(assetsRes));
      setShiModel(shiRes);
      setAssetModel(assetsRes);
      setMetadataModel(metadataRes);
      setConfigModel(configData);
    } catch (err) {
      console.error(err);
      if (typeof cb === 'function') cb(err);
    }
  };

  return { boot, shiModel, configModel, metadataModel, assetModel };
};
